<template>
  <div
    class="accordion__item"
    v-if="fields && fields.heading && fields.content"
    :class="{ open: toggleOn }"
  >
    <div class="accordion__item--title" @click="toggle">
      <div
        class="accordion__item--icon"
        v-if="
          fields &&
          fields.icon &&
          fields.icon.value &&
          fields.icon.value.src &&
          fields.icon.value.src.length > 0
        "
      >
        <sc-image v-if="fields && fields.icon" :media="fields.icon" />
      </div>
      <sc-text tag="h4" v-if="fields && fields.heading" :field="fields.heading" />
    </div>
    <sc-rich-text
      tag="div"
      class="accordion__item--content"
      v-if="fields && fields.content"
      :field="fields.content"
    />
  </div>
</template>

<script>
import { Image, Text, RichText } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Accordion-Item',
  components: {
    ScImage: Image,
    ScText: Text,
    ScRichText: RichText
  },
  props: {
    fields: {
      type: Object
    }
  },
  data: function () {
    return {
      toggleOn: false
    };
  },
  methods: {
    toggle() {
      this.toggleOn = !this.toggleOn;
    }
  }
};
</script>
